<template>
  <el-dialog
    class="add-user-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <el-form
      ref="editForm"
      :model="editForm"
      :rules="editRule"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
    >
      <el-form-item label="用户名" prop="username">
        <el-input v-model.trim="editForm.username" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="用户类型" prop="roleId">
        <el-select
          v-model="editForm.roleId"
          placeholder="请选择"
          class="auto-width"
          :disabled="isEdit && loginUser.ID === userId"
        >
          <el-option
            v-for="item in options"
            :key="item.Id"
            :label="item.Name"
            :value="item.Id"
            :disabled="item.Status !== 'normal'"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="!isEdit" label="登录密码" prop="md5Password">
        <el-input
          v-model.trim="editForm.md5Password"
          type="password"
          placeholder="请输入"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item v-if="!isEdit" label="确认密码" prop="confirmPwd">
        <el-input
          v-model.trim="editForm.confirmPwd"
          type="password"
          placeholder="请输入"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="editForm.email" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="editForm.phone" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-switch
          v-model="editForm.status"
          :active-value="num[1]"
          :inactive-value="num[0]"
        ></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel()">取消</el-button>
      <el-button type="primary" @click="handleOk()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
import { handleEncrpty } from '@/utils/sm4Func'
export default {
  name: 'AddUser',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 80
  },
  data() {
    // 密码复杂度验证：大写字母、小写字母、数字、特殊字符中三种组合，长度为8-20位
    let validatePasswordComplexity = (rule, value, callback) => {
      if (this.isEdit) {
        callback()
        return
      }
      if (!value) {
        callback(new Error('请输入密码'))
        return
      }

      // 检查长度
      if (value.length < 8 || value.length > 20) {
        callback(new Error('密码长度为8-20位'))
        return
      }

      // 检查是否与用户名相同或包含用户名
      if (this.editForm.username && value.toLowerCase() === this.editForm.username.toLowerCase()) {
        callback(new Error('密码不能与用户名相同'))
        return
      }
      if (this.editForm.username && value.toLowerCase().includes(this.editForm.username.toLowerCase())) {
        callback(new Error('密码不能包含用户名'))
        return
      }

      // 检查复杂度：大写字母、小写字母、数字、特殊字符中至少三种组合
      let hasUpperCase = /[A-Z]/.test(value)
      let hasLowerCase = /[a-z]/.test(value)
      let hasNumber = /[0-9]/.test(value)
      let hasSpecialChar = /[^A-Za-z0-9]/.test(value)

      let complexityCount = 0
      if (hasUpperCase) complexityCount++
      if (hasLowerCase) complexityCount++
      if (hasNumber) complexityCount++
      if (hasSpecialChar) complexityCount++

      if (complexityCount < 3) {
        callback(new Error('密码必须包含大写字母、小写字母、数字、特殊字符中的三种组合'))
        return
      }

      callback()
    }

    // 确认密码验证：必须与登录密码一致
    let validateConfirmPassword = (rule, value, callback) => {
      if (this.isEdit) {
        callback()
        return
      }
      if (!value) {
        callback(new Error('请输入确认密码'))
        return
      }
      if (value !== this.editForm.md5Password) {
        callback(new Error('确认密码必须与登录密码一致'))
        return
      }
      callback()
    }

    let isValidate = (rule, value, callback) => {
      if (this.isEdit) {
        callback()
      } else {
        if (value !== '') {
          callback()
        } else {
          callback(new Error('请输入密码'))
        }
      }
    }
    return {
      title: '新增用户',
      dialogVisible: false,
      editRule: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        roleId: [{ required: true, message: '请选择用户类型', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          {
            pattern: /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g,
            message: '请输入正确的邮箱',
            trigger: 'blur'
          }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '请输入合法手机号/电话号',
            trigger: 'blur'
          }
        ],
        status: [{ required: true, message: '请选择状态', trigger: 'blur' }],
        md5Password: [
          { required: true, validator: validatePasswordComplexity, trigger: 'blur' }
        ],
        confirmPwd: [
          { required: true, validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },
      editForm: {
        username: '',
        roleId: 2,
        email: '',
        phone: '',
        status: 1,
        md5Password: '',
        confirmPwd: ''
      },
      sendForm: {
        username: '',
        roleId: 2,
        email: '',
        phone: '',
        status: 1,
        md5Password: ''
      },
      userId: '',
      num: [0, 1],
      options: [],
      isEdit: false,
      loginUser: {},
      adaptationVars: {
        formLabelWidth: 120
      }
    }
  },
  watch: {
    // 当用户名变化时，重新验证密码字段
    'editForm.username'() {
      if (!this.isEdit && this.$refs.editForm) {
        // 如果密码字段有值，重新验证
        if (this.editForm.md5Password) {
          this.$refs.editForm.validateField('md5Password')
        }
      }
    },
    // 当登录密码变化时，重新验证确认密码字段
    'editForm.md5Password'() {
      if (!this.isEdit && this.$refs.editForm) {
        // 如果确认密码字段有值，重新验证
        if (this.editForm.confirmPwd) {
          this.$refs.editForm.validateField('confirmPwd')
        }
      }
    }
  },
  methods: {
    getRoleOptions() {
      let param = {
        offset: 0,
        limit: 50
      }
      this.$apis.system.getRoleList(param).then(res => {
        if (res.data.items) {
          this.options = res.data.items
          if (!this.isEdit) {
            let item = this.options.filter(ele => ele.Status === 'normal')
            this.editForm.roleId = item.length > 0 ? item[0]['Id'] : ''
          }
        }
      })
    },
    handleOpen(data) {
      this.getRoleOptions()
      if (data) {
        this.isEdit = true
        this.title = '编辑用户'
        this.userId = data.id
        let obj = Object.keys(this.editForm)
        obj.map(ele => {
          this.editForm[ele] = data[ele]
        })
        let userInfoStr = localStorage.getItem('cbaas_system_userInfo')
        let userInfo = JSON.parse(userInfoStr)
        this.loginUser = userInfo
      } else {
        this.isEdit = false
        this.title = '新增用户'
      }
      this.dialogVisible = true
    },
    handleCancel() {
      this.editForm = {
        username: '',
        roleId: 2,
        email: '',
        phone: '',
        status: 1,
        md5Password: '',
        confirmPwd: ''
      }
      this.userId = ''
      this.$refs.editForm.clearValidate()
      this.dialogVisible = false
      this.isEdit = false
    },
    handleOk() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          if (this.isEdit) {
            let param = {
              id: this.userId,
              email: this.editForm.email,
              phone: this.editForm.phone,
              roleId: this.editForm.roleId,
              status: this.editForm.status,
              username: this.editForm.username
            }
            this.$apis.system.reviseUser(param).then(res => {
              if (res) {
                this.$message.success('编辑用户成功')
                this.$emit('update:list')
                this.handleCancel()
              }
            })
          } else {
            let keys = Object.keys(this.sendForm)
            keys.map(ele => {
              if (ele === 'md5Password' && !this.isEdit) {
                this.sendForm[ele] = handleEncrpty(this.editForm.md5Password)
              } else {
                this.sendForm[ele] = this.editForm[ele]
              }
            })
            this.$apis.system.addUser(this.sendForm).then(res => {
              if (res) {
                this.$message.success('新增用户成功，请于密码有效期前修改密码')
                this.$emit('update:list')
                this.handleCancel()
              }
            })
          }
        } else {
          this.$message.warning('请完善信息')
          return
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.add-user-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-width);
  }
}
</style>
